<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <router-view />
    <InstallPwaButton />
    <ReloadPrompt />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { useAuthStore } from './stores/auth'
import { useUserStore } from './stores/user'
import InstallPwaButton from './components/InstallPwaButton.vue'
import ReloadPrompt from './components/ReloadPrompt.vue'

let authStore: ReturnType<typeof useAuthStore> | null = null
let userStore: ReturnType<typeof useUserStore> | null = null

// Handle auth state changes from other tabs/windows
const handleStorageChange = (event: StorageEvent) => {
  if (event.key === 'supabase_session' || event.key === 'supabase_user') {
    authStore?.initFromLocalStorage()
  }
}

// Initialize auth on app mount
onMounted(async () => {
  authStore = useAuthStore()
  userStore = useUserStore()

  // Initialize auth store
  if (!authStore.state.initialized) {
    await authStore.initAuth()
  }
  // Initialize user profile if authenticated
  if (authStore.isAuthenticated && !userStore.state.initialized) {
    await userStore.initProfile()
  }
  // Set up auth state change listener
  window.addEventListener('storage', handleStorageChange)
})

onUnmounted(() => {
  window.removeEventListener('storage', handleStorageChange)
})
    
</script>

<style>
@import './assets/main.css';

#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>